/**
 * description_paquet format canonique: "1-2-3" (MEL / ProductColorsModal).
 * Lecture compatible avec l'ancien format "1,2,3" et JSON "[1,2,3]".
 */
export function parseDescriptionPaquet(
  raw: string | null | undefined,
): number[] {
  if (raw == null || String(raw).trim() === "") return [];
  const trimmed = String(raw).trim();
  if (trimmed.startsWith("[")) {
    try {
      return (JSON.parse(trimmed) as unknown[]).map((v) => Number(v) || 0);
    } catch {
      return [];
    }
  }
  return trimmed.split(/[-,]/).map((part) => {
    const n = parseInt(part.trim(), 10);
    return Number.isNaN(n) ? 0 : n;
  });
}

export function formatDescriptionPaquet(
  quantities: Array<number | null | undefined>,
): string {
  return quantities.map((q) => String(q ?? 0)).join("-");
}
